import { Component, OnInit, ChangeDetectorRef, Renderer2, Inject } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { SpinnerService } from './spinner.service';

// Color theme map matching settings.component.ts ColorOption values
const THEME_COLORS: Record<string, { light: string; mid: string; shadow: string; border: string }> = {
  ''       : { light: '#e8d9c4', mid: '#d4c4a8', shadow: '#b8a282', border: '#c9b48e' }, // default warm
  emerald  : { light: '#d1fae5', mid: '#a7f3d0', shadow: '#6ee7b7', border: '#34d399' },
  rose     : { light: '#ffe4e6', mid: '#fecdd3', shadow: '#fda4af', border: '#fb7185' },
  amber    : { light: '#fef3c7', mid: '#fde68a', shadow: '#fcd34d', border: '#fbbf24' },
  violet   : { light: '#ede9fe', mid: '#ddd6fe', shadow: '#c4b5fd', border: '#a78bfa' },
  indigo   : { light: '#e0e7ff', mid: '#c7d2fe', shadow: '#a5b4fc', border: '#818cf8' },
};

const ACCENT_COLORS: Record<string, string> = {
  ''       : '#a89070',
  emerald  : '#10b981',
  rose     : '#f43f5e',
  amber    : '#f59e0b',
  violet   : '#8b5cf6',
  indigo   : '#5b6af0',
};

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner-component.html',
  styleUrls: ['./spinner-component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class SpinnerComponent implements OnInit {
  datas: any;
  letters = ['A', 'e', 'l', 'u', 'm', 'n', 'i'];

  // reactive color properties
  tileGradient = `linear-gradient(145deg, ${THEME_COLORS[''].light}, ${THEME_COLORS[''].mid})`;
  tileBorder   = THEME_COLORS[''].border;
  tileShadow   = THEME_COLORS[''].shadow;
  accentColor  = ACCENT_COLORS[''];

  constructor(
    private spinnerService: SpinnerService,
    private cdRef: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    // listen for spinner on/off
    this.spinnerService.dataemitterr.subscribe((data) => {
      this.datas = data;
      this.cdRef.detectChanges();
    });

    // listen for theme color changes
    this.spinnerService.sidebarLogo.subscribe(() => {
      this.applyThemeColor();
      this.cdRef.detectChanges();
    });

    // apply on init from saved value
    this.applyThemeColor();
  }

  private applyThemeColor(): void {
    const saved = localStorage.getItem('app_color') ?? '';
    const theme = THEME_COLORS[saved] ?? THEME_COLORS[''];
    this.tileGradient = `linear-gradient(145deg, ${theme.light}, ${theme.mid})`;
    this.tileBorder   = theme.border;
    this.tileShadow   = theme.shadow;
    this.accentColor  = ACCENT_COLORS[saved] ?? ACCENT_COLORS[''];
  }
}